import HomepageIndex from './homepage-index';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default class HomepageIndexDesktop extends HomepageIndex {
	constructor(...args) {
		super(...args);

		this._initDom();
		
		if (!document.body.classList.contains('internet')) {
			this._initParallax();
			this._initAnimStrat();
		}
	}

	_loadPage() {
		window.onload = function() {
			document.body.querySelector('.mask-loading').style.pointerEvents = "none";
			TweenMax.to(this.dom.maskLoading, 1.5, {
				autoAlpha: 0
			});
			this.dom.blob.classList.add('loaded');
			this.dom.bgHeader.classList.add('loaded');
		}.bind(this);
	}

	_initDom() {
		this.dom.strat = this.dom.page.querySelectorAll('.js-strat');
		this.dom.blob = this.dom.page.querySelector('.js-blob');
		this.dom.parallax = this.dom.page.querySelectorAll('.js-parallax');
		this.dom.bgHeader = this.dom.page.querySelector('.ct--header');
		this.dom.maskLoading = document.body.querySelector('.mask-loading');
	}

	_initAnimStrat() {
		for (let i = 0; i < this.dom.strat.length; i++) {
			let strat = this.dom.strat[i];
			let index = i;
			let controller = new ScrollMagic.Controller();

			// build scene
			new ScrollMagic.Scene({triggerElement: strat, duration: strat.offsetHeight, offset: 0})
				.on('enter', ()=>{
					this.dom.blob.setAttribute('data-strat', 'strat-' + index)
				})
				.addTo(controller);
		}
	}

	_initParallax() {
		for (let i = 0; i < this.dom.parallax.length; i++) {
			let el = this.dom.parallax[i];
			// let parentIndex = +el.getAttribute('data-strat');
			let speed = +el.getAttribute('data-speed');
			let start = (+el.getAttribute('data-start') != '') ? +el.getAttribute('data-start') : 75;
			let parent = this._findAncestor(el, 'strat');
			let controller = new ScrollMagic.Controller();
			let tween = TweenMax.fromTo(el, 1, {y: start * speed}, {y: -75 * speed, ease: Power1.easeInOut});

			// build scene
			let scene = new ScrollMagic.Scene({triggerElement: parent, duration: parent.offsetHeight})
				.setTween(tween)
				.addTo(controller);
		}
	}

	_findAncestor (el, cls) {
		while ((el = el.parentNode) && el.className.indexOf(cls) < 0);
		return el;
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/homepage/homepage-index.desktop.js